export default __webpack_public_path__ + "a35a3ab3ab0014f08a95c1d808c5811d.png";